<div
  [class]="'prevent-select inline-block ' + getAppearanceClassName()"
  prlwResponsive
>
  <div [class]="'container ' + getAppearanceClassName()">
    <div
      *ngFor="let item of items; let i = index"
      [class]="'item ' + getAppearanceClassName()"
      [class.active]="i === currentIndex"
      (click)="click(i)"
      prlwResponsive
    >
      <svg
        class="dot"
        *ngIf="item.color && appearance === 'rounded-border'"
        width="6"
        height="6"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        prlwResponsive
      >
        <circle cx="3" cy="3" r="3" [attr.fill]="item.color" />
      </svg>
      {{ item.label }}
    </div>
  </div>
</div>
